import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useWebRouter } from "~utils/next-router/use-web-router";
import {
	GetCustomMakerIconsQuery,
	GetCustomMakerIconsQueryVariables,
} from "~map-editor/types/__generated/gql/graphql";
import { graphierQLNextClient } from "utils";

export type GetCustomMakerIconsVariables = GetCustomMakerIconsQueryVariables;
export type GetCustomMakerIconsResults =
	GetCustomMakerIconsQuery["getCustomMakerIcons"];

const query = /* GraphQL */ `
	query GetCustomMakerIcons {
		getCustomMakerIcons {
			id
			accountId
			name
			iconUrl
			size
		}
	}
`;

export const getCustomMakerIconsQueryKey = () => ["getCustomMakerIcons"];

export const useGetCustomMakerIcons =
	(): UseQueryResult<GetCustomMakerIconsResults> => {
		const router = useWebRouter();
		return useQuery({
			enabled: !!router._query.accountName,
			queryKey: getCustomMakerIconsQueryKey(),
			queryFn: () =>
				graphierQLNextClient<
					GetCustomMakerIconsQuery,
					GetCustomMakerIconsQueryVariables
				>({
					query,
					useKey: true,
				}).then((res) => res.getCustomMakerIcons),
		});
	};
